export default "__VITE_ASSET__CDRBBKYK__"